import { CHANGE_VISIBILITY_CHATICON } from '../constants/chatIcon';

/**
 *
 * @param {boolean} showIcon
 * @returns
 */

export const showChatIcon = showIcon => {
  return {
    type: CHANGE_VISIBILITY_CHATICON,
    payload: {
      showIcon,
    },
  };
};
